import Swal from 'sweetalert2';
import mylogo from '../../assets/logotrackhr.png'
import './customswal.css';

export const showCustomSwal = (text) => {
  Swal.fire({
    html: `
      <div style="display: flex; align-items: center; color: white;">
        <img src="${mylogo}" alt="icon" width="25" style="vertical-align: middle; margin-right: 8px;" />
        <span>${text}</span>
      </div>
    `,
    position: 'bottom',
    width: 'auto',
    background: '#1e1e1e',
    timer: 1000,
    showConfirmButton: false,
    customClass: {
      popup: 'no-padding-popup',
    }
  });
};
